import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-powered-by-lm',
  templateUrl: './powered-by-lm.component.html',
  styleUrls: ['./powered-by-lm.component.scss']
})
export class PoweredByLmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
